import React from 'react';
import { useController } from 'react-hook-form';
import {
  FormInputLabel,
  FormInputRadio,
  FormInputRadioContent,
} from '../StyledComponents';

const Radio = ({
  name,
  control,
  rules,
  placeholder,
  checked,
  onChangeDefault,
  marginTop = '',
  fontSize = '',
  value: valueProps,
  marginRight = '10px',
   disabled = false,
}) => {
  const {
    field: { value, onChange },
  } = useController({ control, name, rules });

  return (
    <FormInputRadioContent>
      <FormInputRadio
        disabled={disabled}
        type="radio"
        value={value}
        checked={checked}
        marginRight={marginRight}
        onChange={() => {
          if (onChangeDefault) onChangeDefault(valueProps);
          onChange(valueProps);
        }}
      />
      <FormInputLabel>
        <label style={{ marginTop: marginTop, fontSize: fontSize }}>
          {placeholder}
        </label>
      </FormInputLabel>
    </FormInputRadioContent>
  );
};

export default Radio;
